import { MONITOR_SERIES_TYPES } from '../models/monitor-series-types';
import { FLEX_DIAGNOSTIC_WINDOW_NO_SESSION, FlexDiagnosticWindow } from '../models/flex-diagnostic-window';
import { LocationStatus } from '../models/locations';

const MINIMUM_VALID_DIAGNOSTIC_WINDOW_YEAR = 2;

export function isUnscheduledFlexDiagnosticWindow(window: FlexDiagnosticWindow): boolean {
    const endTime = new Date(window.endTime);
    const hasInvalidEndTime =
        Number.isNaN(endTime.getTime()) || endTime.getUTCFullYear() < MINIMUM_VALID_DIAGNOSTIC_WINDOW_YEAR;

    return window.extendSession === FLEX_DIAGNOSTIC_WINDOW_NO_SESSION && hasInvalidEndTime;
}

export function isOpenFlexDiagnosticWindow(
    series: string | null | undefined,
    currentConnect: boolean | null | undefined,
    diagnosticWindow: boolean | null | undefined,
    status: LocationStatus | null | undefined,
): boolean {
    return (
        series?.toUpperCase() === MONITOR_SERIES_TYPES.FLEX &&
        !!currentConnect &&
        !!diagnosticWindow &&
        status === LocationStatus.Active
    );
}
